import { compose } from "redux";
import { connect } from "react-redux";
import debounce from "lodash/debounce";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";
import { reduxForm } from "redux-form/immutable";

import {
  ACTIONS,
  SUB_CONTRACTOR_FORM,
} from "features/planner/planner.constants";

import {
  subContractorDetailsOnLoad,
  updateSubContractorFormOnChange,
} from "features/planner/planner.actions";

import BasePage from "app/components/BasePage";
import { getActionDataStateFromState } from "app/app.selectors";
import { getSubContractorFromState } from "features/planner/planner.selectors";
import SubContractorDetailsForm from "features/planner/subcontractor/details/components/SubContractorDetailsForm";
import SubContractorContractForm from "features/planner/subcontractor/details/components/SubContractorContractForm";
import SubContractorDepartureForm from "features/planner/subcontractor/details/components/SubContractorDepartureForm";

class SubContractorDetailsContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad, subContractor } = this.props;

    dispatchOnLoad(subContractor);
  }

  render() {
    const { subContractor, dataState } = this.props;

    return (
      <BasePage dataState={dataState}>
        <Grid container spacing={4}>
          <SubContractorDetailsForm />
          <SubContractorContractForm
            markers={subContractor.getIn(["employee", "markers"])}
          />
          <SubContractorDepartureForm />
        </Grid>
      </BasePage>
    );
  }
}

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      dataState: getActionDataStateFromState(state, ACTIONS.GET_SUB_CONTRACTOR),
      subContractor: getSubContractorFromState(state, employeeCardId),
    }),
    {
      dispatchOnLoad: subContractorDetailsOnLoad,
    },
  ),
  reduxForm({
    form: SUB_CONTRACTOR_FORM.ID,
    onChange: debounce(updateSubContractorFormOnChange, 1500),
  }),
)(SubContractorDetailsContainer);
